const UserEmail = require('common/domain/entity/user-email');
const Backbone = require('backbone');

module.exports = Backbone.Collection.extend({
    model: UserEmail,

    initialize: function() {
        this.on('change:primary', (model) => {
            if(model.get('primary')) {
                this.each((m) => {
                    if(m != model) {
                        m.set({primary: false});
                    }
                });
            }
        });
    },

    getPrimary: function() {
        return this.find(ue => {
            return ue.isPrimary();
        });
    }
});



// WEBPACK FOOTER //
// ./common/domain/collection/user-email.js